import { create } from 'zustand';

/**
 * Open/close state for the `/help` modal that lists the slash-command
 * palette. Owned by Zustand so the composer's `execute()` callback can
 * toggle it from outside the modal subtree.
 */
interface HelpModalState {
  open: boolean;
  setOpen: (open: boolean) => void;
  openModal: () => void;
  closeModal: () => void;
}

export const useHelpModalStore = create<HelpModalState>((set) => ({
  open: false,
  setOpen: (open) => set({ open }),
  openModal: () => set({ open: true }),
  closeModal: () => set({ open: false }),
}));
